var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_MENU_DATA, SET_LOADING_START, SET_LOADING_STOP, SET_PRODUCTS_DATA, SET_SELECTED_MENU_ITEM, SET_RELOAD_NOTIFICATION_IS_SHOWN, } from './actions';
export var initialState = {
    loading: false,
    menu: [],
    products: [],
    selectedItem: [],
    isReloadNotificationShown: false,
};
export var reducerProducts = function (state, _a) {
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case SET_MENU_DATA:
            return __assign(__assign({}, state), { menu: payload.menu });
        case SET_PRODUCTS_DATA:
            return __assign(__assign({}, state), { products: payload.products });
        case SET_SELECTED_MENU_ITEM:
            return __assign(__assign({}, state), { selectedItem: payload.selectedItem });
        case SET_LOADING_START:
            return __assign(__assign({}, state), { loading: true });
        case SET_LOADING_STOP:
            return __assign(__assign({}, state), { loading: false });
        case SET_RELOAD_NOTIFICATION_IS_SHOWN:
            return __assign(__assign({}, state), { isReloadNotificationShown: true });
        default:
            return state;
    }
};
